import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ReleaseNotesState {
  /** Zuletzt bestätigte Version. null = dieser Browser hat noch nie etwas gesehen. */
  lastSeenVersion: string | null;
  markSeen: (version: string) => void;
}

export const useReleaseNotesStore = create<ReleaseNotesState>()(
  persist(
    (set) => ({
      lastSeenVersion: null,
      markSeen: (version: string) => set({ lastSeenVersion: version }),
    }),
    {
      name: 'release-notes-storage',
    }
  )
);

export default useReleaseNotesStore;
